// Components==============
import {
    faFile,
    faFileExcel,
    faFilePdf,
    faFilePowerpoint,
    faFileWord,
    faFolder,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import './Image.module.scss';
// =========================

export default function Image({ file, folder }) {
    const localType = file?.toLowerCase();

    if (folder)
        return <FontAwesomeIcon icon={faFolder} styleName="image folder" />;

    if (
        localType.includes('.png') ||
        localType.includes('.jpg') ||
        localType.includes('.jpeg') ||
        localType.includes('.svg')
    )
        return <img src={file} alt="file" />;

    if (localType.includes('.pdf'))
        return <FontAwesomeIcon icon={faFilePdf} styleName="image" />;

    if (localType.includes('.doc'))
        return <FontAwesomeIcon icon={faFileWord} styleName="image" />;

    if (localType.includes('.xlxs'))
        return <FontAwesomeIcon icon={faFileExcel} styleName="image" />;

    if (localType.includes('.ppt'))
        return <FontAwesomeIcon icon={faFilePowerpoint} styleName="image" />;

    return <FontAwesomeIcon icon={faFile} styleName="image" />;
}
